import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import { StreamMessage } from 'utils/messages/StreamMessage';

export function useSignalCapsuleMessagesInMyPortfolioCapsules(
    symbol: string,
    useStreamedDataMessages: (
        symbol: string,
        config: SignalTileConfigState
    ) => StreamMessage[]
) {
    const { config } =
        useMyPortfolioCapsuleConfigSlice<SignalTileConfigState>();

    return useStreamedDataMessages(symbol, config);
}
